import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setCheckWallet, setConfirmWallet } from "../redux/actions/app";
import { closePopup, tradeBorrow } from "../redux/actions/modal";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function (props) {
  const { showPopup, togglePopup, onClick } = props;
  const [isApproved, setIsApproved] = useState(false);
  const confirmHandler = (e) => {
    e.preventDefault();
  };

  const approveHandler = (e) => {
    e.preventDefault();
    if (isApproved) {
      onClick();
      setIsApproved(false);
      togglePopup();
    } else {
      return;
    }
  };

  return showPopup ? (
    <div className={"back-wrapper initialized"}>
      <div className="modal modal_w550 modal-max">
        <div className="modal-wallet__close-window">
          <button
            className="custom-cross-btn custom-cross-btn_black close_btn"
            onClick={(e) => {
              e.preventDefault(), togglePopup();
            }}
          ></button>
        </div>
        <div>
          <img
            style={{ margin: "0 auto" }}
            src="/assets/images/page-icons/point.svg"
            alt="point"
          />
        </div>
        <p>
          Please have the amount of interest in the asset borrowed available in
          your wallet to cover the full or partial "repayment" of the loan.
        </p>

        <div className="approve_modal_main">
          <label
            htmlFor={"approved_check"}
            className="v-form__label"
            onChange={() => setIsApproved(!isApproved)}
          >
            <input
              type="checkbox"
              name="check-name"
              id={"approved_check"}
              className="v-form__hidden"
              checked={isApproved}
            />
            <div className="v-form__checkbox"></div>I understand
          </label>
          <button
            className="custom-gradient-btn custom-gradient-btn_inverse farm-modal__btn"
            onClick={approveHandler}
          >
            <span>Approve</span>
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
